export const kLSAppPrefix = '@rosebud'
export const kLSKeyForEntryDraft = 'draft'
export const kLSKeyForSignOut = 'intentionalSignOut'
export const kLSKeyForTemplateInfo = 'seenTemplateInfo'
